// extracted by mini-css-extract-plugin
export default {"sortableHandle":"sortableHandle--xA6rKMQ7Pq"};